import NavBar from "../components/navbar/navBar";
import Footer from "../components/footer";
import Contact from '../components/contact'


const CertificatesPage = () => {
  
  return (
    <>
      <NavBar />
      <Contact/>
      <Footer />
    </>
  );
};

export default CertificatesPage;
